import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { AlertService } from './alert.service';
import { IAlert } from "../Interfaces/Alert.interfaces";

const defaultHeader = {
  "Content-Type": "application/json",
  "Accept": "application/json",
};

const client =
  process.env.REACT_APP_CLIENT
    ? { client: process.env.REACT_APP_CLIENT }
    : {};

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: { ...defaultHeader, ...client },
  withCredentials: true,
});

// 🔑 Interceptor de REQUEST → injeta token dinamicamente
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const userLogged = localStorage.getItem("user");
    if (userLogged) {
      const token = JSON.parse(userLogged).token;
      if (token) {
        if (config.headers) {
          // ✅ tipagem segura no Axios 1.x
          (config.headers as any)["Authorization"] = `Bearer ${token}`;
        } else {
          config.headers = { Authorization: `Bearer ${token}` } as any;
        }
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🎯 Interceptor de RESPONSE → tratamento de erros
api.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => response,
  (error: AxiosError): Promise<AxiosError> => {
    const data: any = error?.response?.data;

    if (error?.response?.status === 401) {
      localStorage.removeItem("bookingDraft");
      localStorage.removeItem("user");
      window.location.href = '/';
    } else if (error?.response?.status === 422) {
      let alerts: IAlert[] = [];
      Object.keys(data?.errors || {}).forEach(key => {
        data?.errors[key].forEach((errorMessage: string) =>
          alerts.push({ text: errorMessage, type: 'error' })
        );
      });
      AlertService.sendAlert(alerts);
    } else if (data?.message) {
      AlertService.sendAlert([{ text: data?.message, type: 'error' }]);
    } else {
      AlertService.sendAlert([{
        text: 'Houve um erro com retorno dos dados. Tente novamente mais tarde.',
        type: 'error'
      }]);
    }

    return Promise.reject(error);
  }
);

// 📌 Métodos HTTP reutilizáveis
const put = async (url: string, params: any = null) => {
  const response = await api.put(url, params);
  return response.data;
};

const del = async (url: string) => {
  const response = await api.delete(url);
  return response.data;
};

const get = async (url: string, params: any = null) => {
  const response = await api.get(url, { params });
  return response.data;
};

const post = async (url: string, params: any) => {
  const response = await api.post(url, params);
  return response.data;
};

const postFormData = async (url: string, formData: any) => {
  const response = await api.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export { put, del, get, post, postFormData };
